import React from 'react';
import _ from 'lodash';
import {Loader, Header, Grid, Button} from 'semantic-ui-react';
import {
  safeMult,
  safeDivide,
  fillArray,
  generateOptionsFromRefData,
  formatDollarOrEmptyString,
  calculatePaymentDispursementsForSubGrants,
} from 'common/utils';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import CostShareHeader from './CostShareHeader';
import CostShareItem from './CostShareItem';
import CustomGridLayout from 'go/components/modules/requestDetails/v3/items/shared/CustomGridLayout';
import {DeleteModal} from 'app-ui-componentlibrary';
import {Alert} from 'componentLibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {ContentDispatch} from 'framework';
import ReactHtmlParser from 'react-html-parser';

const cleanItem = {
  fundingSourceId: '',
  amount: null,
  fundingSourceName: '',
  fundingTypeId: '',
  nonFedSharePercent: '',
  fundAvailabilityDate: '',
  fundCommitmentLetterDate: '',
};

export class CostShare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      costShareItems: [],
      deleteModalActive: false,
      addModalActive: false,
      isActive: true,
      newItems: [],
    };
  }
  getCostSharefundingSource = () => {
    let budget = _.get(this.props, 'data');
    let costShare = _.get(budget, 'share');

    return _.get(costShare, 'fundingSources', []);
  };
  UNSAFE_componentWillMount() {
    this.calculateTotalFundingSources();
    let budget = _.get(this.props, 'data');
    let costShare = _.get(budget, 'share');

    const {context} = this.props;
    const isLoaded = true;
    const {fundingType: fundingTypeIds, fundingSource: fundingSourceIds} = _.get(
      context,
      'programCategoryConfig',
      {}
    );

    const {fundingTypes = {}, fundingSources = {}} = context;
    let costShareItems = _.get(costShare, 'fundingSources', []);
    const fundingTypesFormatted = this.addDefaultValue(
      generateOptionsFromRefData(fundingTypeIds, fundingTypes.FUNDING_TYPE)
    );
    const fundingSourcesFormatted = this.addDefaultValue(
      generateOptionsFromRefData(fundingSourceIds, fundingSources.FUNDING_SOURCE)
    );
    this.setState(
      {
        openModal: false,
        isLoaded: isLoaded,
        costShareItems: costShareItems,
        totalNonFedShare: this.getAppshareValues(),
        costShareConfig: {
          fundingTypeOptions: fundingTypesFormatted,
          fundingSourceOptions: fundingSourcesFormatted,
        },
      },
      () => this.calculateTotalFundingSources()
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(this.state.costShareItems, prevState.costShareItems) ||
      !_.isEqual(this.state.totalNonFedShare, prevState.totalNonFedShare)
    ) {
      this.calculateTotalFundingSources();
    }
  }

  renderCostShareNonFederalAlert(entityType, readOnly) {
    const {validTotalAmount} = this.state;
    if (!readOnly && !validTotalAmount && entityType !== 'subAwardRecommendation') {
      return (
        <Alert
          type="error"
          header="Total non-federal funds source amount"
          content="Total non-federal funds source amount must be equal to the proposed non-federal share amount"
        />
      );
    } else if (readOnly && !validTotalAmount && entityType == 'subAwardRecommendation') {
      return (
        <Alert
          type="warning"
          header="Total non-federal funding source amount"
          content="The proposed non-federal share amount has been changed from the original submission. Non-federal funding sources need to be adjusted."
        />
      );
    }
  }

  renderCostShareItems(readOnly) {
    const {costShareItems, costShareConfig} = this.state;
    const {deleteModalActive} = this.state;

    return (
      <div className="const-share-items-wrapper">
        {_.map(costShareItems, (item, index) => {
          let isValid = true;
          isValid = this.checkCostShareItemValidity(index);
          return (
            <CustomGridLayout
              headerTitle={
                item.fundingSourceId === undefined
                  ? 'Funding source:'
                  : `Funding source: ${item.fundingSourceId}`
              }
              tier={2}
              name={index}
              deletable={true}
              editable={!readOnly}
              expand={index >= this.state.oldItems ? true : false}
              handleRemove={this.toggleDeleteModal}
              isNarrative={false}
              sourcePath={`cost-share-item-${index}`}
              isValid={isValid}
              itemLabel={`funding source`}
              total={{
                amount: item.amount,
                nonFedSharePercent: item.nonFedSharePercent,
              }}
              templatedValue={true}
              gridLayout={true}
              deleteItem={this.toggleDeleteModal}
            >
              {
                <DeleteModal
                  displayTitle={`Remove funding source`}
                  open={deleteModalActive}
                  cancelAction={this.toggleDeleteModal}
                  deleteAction={() => this.handleItemDelete(index)}
                  displayText={`Are you sure you want to remove ${item.fundingSourceId}? This cannot be undone.`}
                />
              }
              <CostShareItem
                key={`cost-share-item-ground-${index}`}
                id={index}
                item={item}
                expanded={false}
                editable={!readOnly}
                totalNonFedShare={this.state.totalNonFedShare}
                itemConfig={costShareConfig}
                handleItemChange={(item, id, fieldName) => {
                  this.handleItemChange(item, id, fieldName);
                }}
                handleBlur={(item, fieldName, id, x) => {
                  this.handleBlur(item, fieldName, id, true);
                }}
                type={'ground'}
                doRecalculate={true}
                validationErrors={this.props.dynamicComponent.validationErrors}
                validationDirtyMap={this.props.dynamicComponent.validationDirtyMap}
                validationErrorPath={this.props.validationErrorPath}
              />
            </CustomGridLayout>
          );
        })}
      </div>
    );
  }
  toggleDeleteModal = () => {
    this.setState((prevState) => ({
      deleteModalActive: !prevState.deleteModalActive,
    }));
  };

  handleItemChange = (item, id, fieldName) => {
    const newItems = _.cloneDeep(this.state.costShareItems);
    _.set(newItems, id, item);
    this.setState({
      costShareItems: newItems,
    });
  };

  handleItemDelete = (id) => {
    const newItems = _.cloneDeep(this.state.costShareItems);
    _.pullAt(newItems, id);
    this.setState({
      costShareItems: newItems,
    });
    this.saveData(newItems);
    this.toggleDeleteModal();
  };

  saveData = (newItems, fieldName, id, noValidation) => {
    if (noValidation) {
      this.props.saveEntityData(
        this.props.entityDataPath + '.share.fundingSources',
        this.props.entityType,
        newItems,
        `${'costshare'}[${id}].${fieldName}`,
        null,
        this.props.entityTypeReduxPath
      );
    } else {
      this.props.saveEntityData(
        this.props.entityDataPath + '.share.fundingSources',
        this.props.entityType,
        newItems,
        false,
        null,
        this.props.entityTypeReduxPath
      );
    }
  };

  handleBlur = (item, fieldName, id, noValidation) => {
    const newItems = _.cloneDeep(this.state.costShareItems);
    const updatedItems = _.set(newItems, id, item);
    this.saveData(updatedItems, fieldName, id, noValidation);
  };

  calculateTotalFundingSources() {
    let totalLinesAmount = 0;
    _.forEach(this.state.costShareItems, (item) => {
      if (item.amount) {
        totalLinesAmount += _.toNumber(item.amount);
      }
    });
    this.calculateNonFedSharePercent(totalLinesAmount.toFixed(2));
  }

  getAppshareValues = () => {
    return fillArray(
      _.get(
        this.props,
        _.get(this.props, 'useActualPaths')
          ? 'data.share.actualAppShare'
          : 'data.share.appShare',
        []
      ),
      '0.00'
    );
  };

  calculateNonFedSharePercent(totalFundingSources) {
    const nonFedShare = this.getAppshareValues();
    let newItems = _.cloneDeep(this.state.costShareItems);
    let nonFedSharePercentValue;
    _.forEach(newItems, (item) => {
      nonFedSharePercentValue = 0;
      if (item.amount && !_.isEmpty(nonFedShare)) {
        nonFedSharePercentValue = safeDivide(
          safeMult(item.amount, 100),
          _.sum(_.map(nonFedShare, _.toNumber))
        ).toFixed(2);
      }
      _.set(
        item,
        'nonFedSharePercent',
        nonFedSharePercentValue ? nonFedSharePercentValue : null
      );
    });
    // show alert if total amount for line items is less that Non-Fed share
    let validTotalAmount =
      _.toNumber(totalFundingSources) != _.sum(_.map(nonFedShare, _.toNumber)).toFixed(2)
        ? false
        : true;
    this.setState({
      costShareItems: newItems,
      totalNonFedShare: nonFedShare,
      validTotalAmount: validTotalAmount,
      totalFundingSources: totalFundingSources,
    });
  }

  render() {
    const {isLoaded, costShareItems, costShareConfig} = this.state;
    const {allowZeroTotalAmount, showFundingSources, useActualPaths} = this.props;

    const totalAmount =
      useActualPaths && _.toString(_.get(this.props.data, 'actualAllowedTotalAmount'))
        ? _.get(this.props.data, 'actualAllowedTotalAmount')
        : _.get(this.props.data, useActualPaths ? 'actualTotalAmount' : 'totalAmount', 0);

    if (!isLoaded) {
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    }
    if (!allowZeroTotalAmount && totalAmount <= 0) {
      return <React.Fragment />;
    }

    const currentIndex = costShareItems ? costShareItems.length : 0;

    const isReadOnly =
      this.props.appEntityType === 'subAwardRecommendation'
        ? !this.props.readOnly
        : this.props.readOnly;

    const openModal = () => this.setState({openModal: true});

    return (
      <div className="cost-share">
        <Header as="h3">Cost share</Header>
        <hr />
        {_.map(this.props.contents, (entry, index) =>
          entry.noParentProps ? (
            <ContentDispatch config={entry} key={entry.title} />
          ) : (
            <ContentDispatch
              config={entry}
              key={entry.title}
              entityType={this.props.entityType}
              entityDataPath={this.props.entityDataPath}
              entityTypeReduxPath={this.props.entityTypeReduxPath}
              handlePostSave={this.props.handlePostSave}
              validationErrorPath={this.props.validationErrorPath}
              costShareInstructionalText={this.props.costShareInstructionalText}
              fundingSourcesInstructionalText={this.props.fundingSourcesInstructionalText}
              costShareQuestionDataPath={this.props.costShareQuestionDataPath}
              fundingStreamDataPath={this.props.fundingStreamDataPath}
              configType={this.props.configType}
              configId={this.props.configId}
              appEntityType={this.props.appEntityType}
              totalActivityCosts={[totalAmount]}
              isLoaded={isLoaded}
              useActualPaths={_.get(this.props, 'useActualPaths', false)}
              costShareIndex={this.props.costShareIndex}
              readOnly={
                this.props.appEntityType === 'subAwardRecommendation'
                  ? !this.props.readOnly
                  : this.props.readOnly
              }
              updateNonFedShare={(nonFedShare) => {
                this.setState({totalNonFedShare: nonFedShare});
              }}
              validationErrors={this.props.dynamicComponent.validationErrors}
              validationDirtyMap={this.props.dynamicComponent.validationDirtyMap}
              showFundingSources={showFundingSources}
            />
          )
        )}
        {showFundingSources && (
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                {ReactHtmlParser(this.props.fundingSourcesInstructionalText)}
                {this.props.appEntityType === 'subAwardRecommendation'
                  ? isReadOnly
                  : !isReadOnly && (
                      <Button
                        className="pull-right"
                        id="add-cost-share-item"
                        primary
                        basic
                        as="a"
                        href="#"
                        onClick={openModal}
                      >
                        + Add funding source
                      </Button>
                    )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        <FemaGoModal
          size="large"
          title="Add funding source"
          open={this.state.openModal}
          buttonText="Add this funding source"
          confirmAction={() => {
            this.setState(
              {
                openModal: false,
                costShareItems: this.getCostSharefundingSource(),
                oldItems: currentIndex,
              },
              () => {
                const item = _.get(this.state.costShareItems, currentIndex);
                this.handleBlur(item, 'fundAvailabilityDate', currentIndex, true);
                this.handleBlur(item, 'fundCommitmentLetterDate', currentIndex, true);
              }
            );
          }}
          cancelAction={() => this.setState({openModal: false})}
        >
          <CostShareItem
            id={currentIndex}
            item={cleanItem}
            expanded={true}
            entityTypeReduxPath={this.props.entityTypeReduxPath}
            validationErrorPath={this.props.validationErrorPath}
            totalNonFedShare={this.getAppshareValues()}
            totalFundingSources={10000}
            itemConfig={costShareConfig}
            handleItemChange={() => {}}
            handleBlur={(item, fieldName, id) => {
              this.handleBlur(item, fieldName, id, false);
            }}
            isModelActive={this.state.openModal}
            editable={!this.props.readOnly}
          />
        </FemaGoModal>
        {showFundingSources &&
          this.renderCostShareNonFederalAlert(
            this.props.appEntityType,
            this.props.readOnly
          )}
        {showFundingSources && this.state.validTotalAmount && (
          <div>
            <br />
          </div>
        )}
        {showFundingSources && (
          <div class="app-tablegrid_column-header cost-share-padding">
            <div class="column-flex-header-contain">
              <div class="table-grid-block first-col-cost-share">
                <h4 class="table-grid-text column-header">Funding source</h4>
              </div>
              <div class="table-grid-block _15perc w-clearfix">
                <h4 class="table-grid-text column-header right-float-align">
                  % Non-federal share by source
                </h4>
              </div>
              <div class="table-grid-block _15perc w-clearfix">
                <h4 class="table-grid-text column-header right-float-align">
                  Funding amount
                </h4>
              </div>
            </div>
          </div>
        )}
        {showFundingSources && this.renderCostShareItems(this.props.readOnly)}
        <p style={{visibility: 'hidden'}}>&nbsp;</p>
        <br />
      </div>
    );
  }

  addDefaultValue = (options) => {
    if (options && options.length > 0 && options[0]) {
      if (_.toLower(_.get(options, [0, 'text'], '')) !== 'Select') {
        let selectItem = {
          text: 'Select',
          value: '',
          key: '0',
        };
        options.splice(0, 0, selectItem);
      }
    }
    return options;
  };

  checkCostShareItemValidity = (id) => {
    const {validationErrors} = this.props.dynamicComponent;
    const baiscPath = `${'costshare'}.${'0'}.${id}.${'isValid'}`;
    return validationErrors ? _.get(validationErrors.errors, baiscPath) : null;
  };
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    context: state.dynamicComponent.context,
    dynamicComponent: state.dynamicComponent,
  };
};

export default connect(mapStateToProps, null)(connectDynamic(CostShare));
